module.exports = __webpack_public_path__ + "img/2.491c0d5c.jpg";